import React from 'react';
import { ContainerErrorInfoStyled as ContainerErrorInfoCard, ErrorInfoPrefixStyled as ErrorInfoPrefix, ErrorIconStyled as ErrorIcon, ErrorTextStyled as ErrorText, LightCrossErrorStyled as LightCross } from './styles/ErrorInfoStyled';
var ErrorInfo = function ErrorInfo(_ref) {
  var error = _ref.error,
    setShowError = _ref.setShowError,
    className = _ref.className;
  return React.createElement(ContainerErrorInfoCard, {
    className: className
  }, React.createElement(ErrorInfoPrefix, null, React.createElement(ErrorIcon, null), React.createElement(ErrorText, null, error)), React.createElement(LightCross, {
    onClick: function onClick() {
      return setShowError(false);
    }
  }));
};
export default ErrorInfo;